import * as types from '../actions/actionTypes';
import { challengeQuestions, adminUsers, adminAccounts } from './initialState';

const initialState = { challengeQuestions, adminUsers, adminAccounts };

export default (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_CHALLENGE_QUESTIONS:
      return { ...state, challengeQuestions: action.payload };
    case types.ADMIN_USER_SEARCHING: {
      return {
        ...state,
        isUserSearching: action.isUserSearching,
      };
    }
    case types.ADMIN_USERS: {
      return {
        ...state,
        adminUsers: action.data.data,
        userSearchQuery: action.data.query,
        isSearched: true,
        isClearUser: false,
        isUserSearching: action.data.isUserSearching,
      };
    }
    case types.ADMIN_ACCOUNTS: {
      return {
        ...state,
        adminAccounts: action.data.data,
        accountSearchQuery: action.data.query,
      };
    }
    case types.CLEAR_ADMIN_USERS_SEARCH: {
      return {
        ...state,
        adminUsers: action.data.data,
        userSearchQuery: action.data.query,
        isSearched: false,
        isClearUser: true,
        isUserSearching: false,
      };
    }
    case types.CLEAR_ADMIN_ACCOUNTS_SEARCH: {
      return {
        ...state,
        adminAccounts: {},
        accountSearchQuery: {},
        isAccountSearched: false,
        isSearched: false,
        isUserSearching: false,
      };
    }
    case types.ADMIN_ACCOUNTS_SEARCH_DATA: {
      return {
        ...state,
        adminAccountsSearchData: action.data.data,
        adminAccountSearchQuery: action.data.query,
        isAdminAcccountSearched: true,
        isClearAdminAccountSearch: false,
        isAdminAccountSearching: action.data.isSearching,
      };
    }
    case types.CLEAR_ADMIN_ACCOUNTS_SEARCH_DATA: {
      return {
        ...state,
        adminAccountsSearchData: {},
        adminAccountSearchQuery: {},
        isAdminAcccountSearched: false,
        isClearAdminAccountSearch: true,
        isAdminAccountSearching: false,
      };
    }
    case types.ADMIN_ADD_USER: {
      return {
        ...state,
        isAddUser: action.isAddUser,
      };
    }
    case types.TOGGLE_ACCOUNT_DETAILS: {
      return {
        ...state,
        showAccountDetails: action.showAccountDetails || false,
        accountDetailsData: {},
      };
    }
    case types.ACCOUNT_DETAILS_SUCCESS: {
      return {
        ...state,
        showAccountDetails: true,
        accountDetailsData: action.data,
      };
    }
    default:
      return state;
  }
}
